const config = {
  dataUrl: '/node/home/api/recommended-destinations',
  options: {
    method: 'GET',
    credentials: 'include',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    }
  }
};

const getRecommendedDestinations = ({ limit }, siteName) =>
  fetch(`${config.dataUrl}?size=${limit}&site=${siteName}`, config.options)
    .then((response) => {
      if (!response.ok) {
        throw Error(response.status);
      }
      return response.json();
    });

export { getRecommendedDestinations };
